import {DocumentInfo} from "../types/document";

export const getImagePath = (info: DocumentInfo, page: number) => {
  return `${process.env.REACT_APP_IMG_URL}/pdf/${info.content.physical_name}/page_img/${page}.jpg`;
};
